<div class="hero">
  <div class="motto-card-container">
    <div class="title">
      <span class="line-gradient">{{ 'login_page.motto_second_line' | translate }}</span>
    </div>

    <div class="info">
      <span class="info-line1">{{ 'login_page.info_first_line' | translate }}</span>
      <span class="info-line2">{{ 'login_page.info_second_line' | translate }}</span>
    </div>

  </div>
</div>